module.exports = __webpack_public_path__ + "img/icon_map_11_off_001.31428f3c.png";